module.exports = __webpack_public_path__ + "static/img/singleLogo.195101ea.svg";